module.exports = "/img/10.ebaa56.webp";